import { ElementRef } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from '../../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { WellbeingScanService } from '../wellbeing-scan.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../wellbeing-scan.service";
import * as i4 from "../../../shared/wellbeing-header/wellbeing-header.component";
import * as i5 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "../../../shared/flow/hide-if-flow.directive";
import * as i7 from "@angular/router";
import * as i8 from "../../../shared/track-user-activity.directive";
import * as i9 from "@angular/common";
function WellbeingStartComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelement(3, "h4", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵelement(5, "h4", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingStartComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelement(3, "h4", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵelement(5, "h4", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingStartComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelement(3, "h4", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function () { return { "track": "click", "name": "ss_booksession_btn_clicked" }; };
const _c1 = function () { return { "track": "click", "name": "ss_how_letsdo_btn_clicked" }; };
export class WellbeingStartComponent extends BaseComponent {
    constructor(elementRef, sessionStorage, modalService, wellbeingScanService) {
        super(sessionStorage, modalService);
        this.elementRef = elementRef;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.wellbeingScanService = wellbeingScanService;
        this.showHowHelpAnswer = false;
        this.showTestResults = false;
        this.showLogIn = false;
        this.flowName = "";
        this.sessionScheduleLink = "";
    }
    ngOnInit() {
        this.wellbeingScanService.clearSavedSrqAnswers();
        this.wellbeingScanService.clearSavedExtraQuestionAnswers();
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        this.sessionScheduleLink = "/match-with-a-coach-start";
    }
}
WellbeingStartComponent.ɵfac = function WellbeingStartComponent_Factory(t) { return new (t || WellbeingStartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.WellbeingScanService)); };
WellbeingStartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingStartComponent, selectors: [["wellbeing-start"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 37, vars: 13, consts: [[1, "olha-theme"], [1, "container", "bg-2"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "h1"], ["jhiTranslate", "inukaNgApp.wellbeingStart.how"], [1, "d-md-none", "h3"], ["src", "../../../../../content/images/wellbeing/hello.png", "alt", "hello"], [1, "wellbeing-start-text"], ["jhiTranslate", "inukaNgApp.wellbeingStart.discoverTitle"], ["jhiTranslate", "inukaNgApp.wellbeingStart.discoverText", 2, "font-weight", "normal"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block"], ["jhiHideIfFlow", "sss", "id", "ss-book-session-btn", 1, "btn", "btn-secondary", "align-items-center", "justify-content-center", 3, "routerLink", "trackUserActivity"], ["jhiTranslate", "inukaNgApp.wellbeingStart.bookASession", 2, "font-weight", "normal"], ["routerLink", "/wellbeing-scan", "id", "ss-start-ss-btn", 1, "btn", "btn-primary", "align-items-center", "justify-content-center", 3, "trackUserActivity"], ["jhiTranslate", "inukaNgApp.wellbeingStart.startScan", 2, "font-weight", "normal", "color", "white"], [1, "d-md-none"], [1, "btn", "btn-secondary", "align-items-center", "justify-content-center", 3, "routerLink", "trackUserActivity"], ["routerLink", "/wellbeing-scan", 1, "btn", "btn-primary", "align-items-center", "justify-content-center", 3, "trackUserActivity"], [1, "wellbeing-start-text", "d-flex", "justify-content-between", 2, "cursor", "pointer", 3, "click"], ["jhiTranslate", "inukaNgApp.wellbeingStart.howHelpQuestion", 1, "h4", 2, "font-weight", "normal", "text-align", "left"], ["src", "../../../../../content/images/wellbeing/vector-down.png", "alt", "vector-down", 1, "arrow-down-icon"], ["class", "wellbeing-start-text", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellbeingStart.testResultQuestion", 1, "h4", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.LogInQuestion", 1, "h4", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.howHelpAnswer1", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.howHelpAnswer2", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.testResultAnswer1", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.testResultAnswer2", 2, "font-weight", "normal", "text-align", "left"], ["jhiTranslate", "inukaNgApp.wellbeingStart.LogInAnswer", 2, "font-weight", "normal", "text-align", "left"]], template: function WellbeingStartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "wellbeing-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelement(4, "h1", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "h3", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div");
        i0.ɵɵelement(8, "img", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelement(10, "h4", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵelement(12, "h4", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵelementStart(14, "button", 10);
        i0.ɵɵelement(15, "h5", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "button", 12);
        i0.ɵɵelement(17, "h5", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵelementStart(19, "div");
        i0.ɵɵelementStart(20, "button", 15);
        i0.ɵɵelement(21, "h5", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div");
        i0.ɵɵelementStart(23, "button", 16);
        i0.ɵɵelement(24, "h5", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 17);
        i0.ɵɵlistener("click", function WellbeingStartComponent_Template_div_click_25_listener() { return ctx.showHowHelpAnswer = !ctx.showHowHelpAnswer; });
        i0.ɵɵelement(26, "a", 18);
        i0.ɵɵelement(27, "img", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, WellbeingStartComponent_div_28_Template, 6, 0, "div", 20);
        i0.ɵɵelementStart(29, "div", 17);
        i0.ɵɵlistener("click", function WellbeingStartComponent_Template_div_click_29_listener() { return ctx.showTestResults = !ctx.showTestResults; });
        i0.ɵɵelement(30, "a", 21);
        i0.ɵɵelement(31, "img", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, WellbeingStartComponent_div_32_Template, 6, 0, "div", 20);
        i0.ɵɵelementStart(33, "div", 17);
        i0.ɵɵlistener("click", function WellbeingStartComponent_Template_div_click_33_listener() { return ctx.showLogIn = !ctx.showLogIn; });
        i0.ɵɵelement(34, "a", 22);
        i0.ɵɵelement(35, "img", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(36, WellbeingStartComponent_div_36_Template, 4, 0, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵpropertyInterpolate("routerLink", ctx.sessionScheduleLink);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(9, _c0));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(10, _c1));
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("routerLink", ctx.sessionScheduleLink);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(11, _c0));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(12, _c1));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showHowHelpAnswer);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showTestResults);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showLogIn);
    } }, directives: [i4.WellbeingHeaderComponent, i5.JhiTranslateDirective, i6.HideIfFlowDirective, i7.RouterLink, i8.TrackUserActivityDirective, i9.NgIf], styles: [".login-img[_ngcontent-%COMP%]{background-size:cover}.score-board[_ngcontent-%COMP%]{background-color:#f8f7f2;border-radius:3.05rem;height:auto;border-spacing:.5rem}.start-score[_ngcontent-%COMP%]{width:4.5rem;height:4.5rem;font-size:.7rem;color:#000}.result-score[_ngcontent-%COMP%]{width:3rem;height:3rem;font-size:.5rem;color:#000}.progress-bar-horizontal[_ngcontent-%COMP%]{margin-top:5px;z-index:0}.progress-bar-horizontal-start[_ngcontent-%COMP%]{width:15rem}.progress-bar-horizontal-result[_ngcontent-%COMP%]{width:10rem}.progress-bar[_ngcontent-%COMP%]{z-index:10}.progress-bar-tough-place[_ngcontent-%COMP%]{border-radius:20px 0 0 20px !important;display:inline-block;z-index:10;background-color:#b894aa}.progress-bar-at-risk[_ngcontent-%COMP%]{border-radius:0 0 0 0 !important;display:inline-block;z-index:10;background-color:#efe199}.progress-bar-resilient[_ngcontent-%COMP%]{border-radius:0 20px 20px 0 !important;display:inline-block;z-index:10;background-color:#a9d3c7}.progress-bar-vertical[_ngcontent-%COMP%]{z-index:0}.vertical-bar[_ngcontent-%COMP%]{height:24px;z-index:20}.number-circle[_ngcontent-%COMP%]{width:20px;height:20px;margin:2px 2px 2px auto}.bar-font-start[_ngcontent-%COMP%]{font-size:.8rem}.bar-font-result[_ngcontent-%COMP%]{font-size:.6rem}.s-resilient[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:78.5%}.s-at-risk[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:37%}.s-in-a-bad-place[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:4.5%}.wellbeing-start-text[_ngcontent-%COMP%]{display:block;margin:20px auto;width:300px;text-align:center}.wellbeing-start-button[_ngcontent-%COMP%]{border-radius:1.7rem;width:10rem;font-size:1rem}.container[_ngcontent-%COMP%]{margin:90px 20px 10px !important;height:auto !important;width:auto;max-width:1169px !important;padding-top:30px;text-align:center}img[_ngcontent-%COMP%]{height:135px;width:135px;margin-top:15px}button[_ngcontent-%COMP%]{margin:0 10px 10px 10px;line-height:25px;height:40px;width:152px}h5[_ngcontent-%COMP%]{font-size:12px;margin:0}ul[_ngcontent-%COMP%]{padding-left:15px}.arrow-down-icon[_ngcontent-%COMP%]{height:7px;width:14px;margin-top:10px}@media(min-width: 768px){.container[_ngcontent-%COMP%]{margin:90px auto 30px !important;padding-top:50px}img[_ngcontent-%COMP%]{height:213px;width:213px;margin-top:20px}.wellbeing-start-text[_ngcontent-%COMP%]{width:478px}button[_ngcontent-%COMP%]{height:50px;width:200px}h5[_ngcontent-%COMP%]{font-size:14px}}"] });
